module.exports = __webpack_public_path__ + "img/11.5bf7bd63.jpg";